import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Status } from "../../../models/response/status/status.model";
import { RootState } from "../../store";

// Define the initial state using that type
const initialState: Status = {
  success: true,
  errorType: 0,
  errorMessage: "",
  step: "",
};

export const StatusSlice = createSlice({
  name: "status",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setStatus: (_status: Status, action: PayloadAction<Status>) => {
      return { ...action.payload };
    },
  },
});

export const { setStatus } = StatusSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectStatus = (state: RootState) => state;

export default StatusSlice.reducer;
